import Update from "@mui/icons-material/Update";
import { Stack, Typography } from "@mui/material";
import { DateTime } from "luxon";

import { dateFormatDayMonthYear } from "../../../utils/dateTimeFormats";
import { type Insight } from "../types";

type UpdatePublishLabelProps = {
  insight: Insight;
};

const UpdatePublishLabel: React.FC<UpdatePublishLabelProps> = ({ insight }) => {
  const updatePublishLabel =
    insight.providerId === "custom" ? insight.customInsightAttributes?.published : insight.lastUpdated;

  return (
    <Stack direction="row" spacing={0.75} alignItems="center" sx={{ mt: 1, mb: 1 }}>
      <Update fontSize="small" sx={{ color: "text.secondary" }} />
      <Typography variant="caption" color="text.secondary">
        {insight.providerId === "custom" ? "Published" : "Last checked"} on&nbsp;
        {DateTime.fromJSDate(new Date(updatePublishLabel ?? "")).toFormat(dateFormatDayMonthYear)}
      </Typography>
    </Stack>
  );
};

export default UpdatePublishLabel;
